<template lang="pug">
div
  div(v-if="!error && !loading" v-html="content")
    //- pre {{layout}}
  spinner(v-else-if="loading" v-model="loading")
  div(v-else)
    error-page(:error="error")
</div>
</template>

<script>
import ErrorPage from "./ErrorPage.vue";
import PageLoad from "../mixins/PageLoad.js";
import HandleError from "../mixins/HandleError.js";
import Spinner from "@/components/Spinner.vue";

export default {
  name: "Page",
  components: {
    ErrorPage,
    Spinner
  },
  mixins: [PageLoad, HandleError],
  data() {
    return {
      content: "",

      // Toggle loading display
      loading: true,
      loadError: null,
      error: false
    };
  },
  created() {
    this.pageLoad();
  }
};
</script>
<style lang="scss">
.row {
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0px 10px 0px;
}

.text-xs {
  font-size: 1vh;
}

.text-sm {
  font-size: 2vh;
}

.text-md {
  font-size: 3vh;
}

.text-lg {
  font-size: 4vh;
}

.text-xl {
  font-size: 5vh;
}

.text-bold {
  font-weight: bold;
}

.text-italic {
  font-style: italic;
}

.text-underline {
  text-decoration: underline;
}

.page-justify {
  -ms-flex-pack: distribute;
  text-align: justify;
  justify-content: space-around;
}

.page-center {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  text-align: center;
  justify-content: center;
}

.page-left {
  text-align: left;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}

.page-right {
  text-align: right;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}

$fullWidth: 88%;
%col {
  min-height: 5vh;
  margin: 5px 0.5% 5px 0.5%;
  padding: 5px;
}

.col-1 {
  @extend %col;
  width: $fullWidth / 12;
}

.col-2 {
  @extend %col;
  width: $fullWidth / 6;
}

.col-3 {
  @extend %col;
  width: $fullWidth / 4;
}

.col-4 {
  @extend %col;
  width: $fullWidth / 3;
}

.col-5 {
  @extend %col;
  width: $fullWidth / 1 * 5;
}

.col-6 {
  @extend %col;
  width: $fullWidth / 2;
}

.col-7 {
  @extend %col;
  width: $fullWidth / 12 * 7;
}

.col-8 {
  @extend %col;
  width: $fullWidth / 12 * 8;
}

.col-9 {
  @extend %col;
  width: $fullWidth / 12 * 9;
}

.col-10 {
  @extend %col;
  width: $fullWidth / 12 * 10;
}

.col-11 {
  @extend %col;
  width: $fullWidth / 12 * 11;
}

.col-12 {
  @extend %col;
  width: $fullWidth;
}
</style>
